<div>
  <h1 mat-dialog-title class="dialogTitle">Statutory Compliance</h1>
  <div mat-dialog-content>
    <div [innerHtml]="data.statutoryTxt" class="dialogContent"></div>
  </div>
  <div mat-dialog-actions align="start">
    <button mat-button class="acceptBtn" (click)="onAccept()" (keyup.enter)="onAccept()" tabindex="0">
      ACCEPT and PROCEED
    </button>
  </div>
</div>
